var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page",
    transform: "translate(-735, -6763)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0, 6401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(627, 362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_youtube",
    transform: "translate(108, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56551283,1.66624741 C-0.315068752,3.61923571 0.069822282,5.69384962 0.069822282,11.9964489 C0.069822282,17.2303379 -0.843546078,22.477187 3.9366809,23.7123849 C5.42938007,24.0962034 18.655273,24.0962034 20.1459779,23.710391 C22.1362435,23.1969714 23.7555778,21.5829397 23.97694,18.7686028 C24.0078509,18.3758119 24.0078509,5.62406443 23.9759428,5.22329807 C23.7406208,2.22552583 21.8949387,0.497843994 19.4629459,0.147921129 C18.9055519,0.0671696985 18.7938737,0.0432433488 15.9341133,0.0382586926 C5.79034005,0.0432433488 3.56674678,-0.408366503 1.56551283,1.66624741 Z",
    id: "Path",
    fill: "#F20A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1491075,8.39203921 C18.8491259,7.46891394 17.8564594,6.90985728 16.942879,6.78168332 C13.6568709,6.43260993 10.3431291,6.43260993 7.05712099,6.78168332 C6.14354059,6.90985728 5.14814703,7.46345973 4.85089251,8.39203921 C4.38320192,10.7750706 4.38320192,13.2262929 4.85089251,15.6093243 C5.15087413,16.5310861 6.14354059,17.0915063 7.05712099,17.2196802 C10.3431291,17.5687536 13.6568709,17.5687536 16.942879,17.2196802 C17.8564594,17.0915063 18.851853,16.5379038 19.1491075,15.6093243 C19.6167981,13.2262929 19.6167981,10.7750706 19.1491075,8.39203921 L19.1491075,8.39203921 Z M10.2055645,14.8743694 L10.2055645,9.12563063 L14.8852778,12 C13.3076472,12.9694861 11.7763773,13.908974 10.2055645,14.8743694 Z",
    id: "icon",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.6b25bdf69d321b4fa12b2321bd731057.svg";
export { ForwardRef as ReactComponent };